module.exports = __webpack_public_path__ + "img/Township at Singarayakonda.4f48b7c1.jpg";